
import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const IndustryHeroSection = () => {
  return (
    <section className="pt-32 pb-20 px-4 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={Gradient}
          alt="EventHub háttér"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30 z-0"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="lg:w-3/4 text-center lg:text-left"
          >
            <div className="inline-block px-3 py-1 bg-white/20 text-white text-sm font-medium rounded-full mb-4 backdrop-blur-sm">
              Minden szakmának kihívás az eseménykezelés
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight hero-heading">
              Szakmai <span className="text-medihub-accent">eseménynaptár</span><br />
              az Ön területére szabva
            </h1>

            <p className="text-lg text-white/90 mb-8 max-w-xl mx-auto lg:mx-0">
              Eseménykezelő platform, amely egyedi igényekre szabva segít a szakmai rendezvények szervezésében, népszerűsítésében és a résztvevők kezelésében
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <Link
                to="/contact"
                className="px-6 py-3 bg-medihub-accent text-white rounded-full font-medium hover:bg-medihub-accent/90 transition-colors shadow-lg hover:shadow-xl hover:shadow-medihub-accent/20 flex items-center justify-center sm:justify-start"
              >
                Egyedi megoldás az Ön területére
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              
              <Link
                to="/industries"
                className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/20 transition-colors flex items-center justify-center sm:justify-start border border-white/20"
              >
                Fedezze fel az iparági megoldásokat
              </Link>
            </div>

            <div className="flex flex-wrap gap-4 justify-center lg:justify-start text-sm text-white mt-8">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
                <CalendarDays className="w-4 h-4 text-medihub-accent mr-2" />
                Jogi események
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
                <CalendarDays className="w-4 h-4 text-medihub-accent mr-2" />
                Mérnöki továbbképzések
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
                <CalendarDays className="w-4 h-4 text-medihub-accent mr-2" />
                Tudományos konferenciák
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
                <CalendarDays className="w-4 h-4 text-medihub-accent mr-2" />
                Oktatási szemináriumok
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default IndustryHeroSection;
